export function CryptoGfg() {
    // Links in an array
    const links = [
      { label: "Intro To Crypto (Basics)", url: "https://www.geeksforgeeks.org/javascript/?ref=lbp" },
      { label: "Comments", url: "https://www.geeksforgeeks.org/javascript-comments/?ref=lbp" },
      { label: "DataTypes", url: "https://www.geeksforgeeks.org/variables-datatypes-javascript/?ref=lbp" },
      { label: "Let", url: "https://www.geeksforgeeks.org/javascript-let/?ref=lbp" },
      { label: "Var", url: "https://www.geeksforgeeks.org/javascript-var/?ref=lbp" },
      { label: "Const", url: "https://www.geeksforgeeks.org/javascript-const/?ref=lbp" },
      { label: "Operators", url: "https://www.geeksforgeeks.org/javascript-operators/?ref=lbp" },
      { label: "Statements", url: "https://www.geeksforgeeks.org/javascript-statements/?ref=lbp" },
      { label: "if-else", url: "https://www.geeksforgeeks.org/javascript-if-else/?ref=lbp" },
      { label: "switch", url: "https://www.geeksforgeeks.org/switch-case-in-javascript/?ref=lbp" },
      { label: "Break", url: "https://www.geeksforgeeks.org/javascript-break-statement/?ref=lbp" },
      { label: "Continue", url: "https://www.geeksforgeeks.org/javascript-continue-statement/?ref=lbp" },
      { label: "Return", url: "https://www.geeksforgeeks.org/javascript-return-statement/?ref=lbp" }
    ];
  
    // Part 2 links
    const part2Links = [
      { label: "Loops, for, while, do-while, for each etc.", url: "https://www.geeksforgeeks.org/loops-in-javascript/?ref=lbp" },
      { label: "Objects, Structure Destructure", url: "https://www.geeksforgeeks.org/objects-in-javascript/?ref=lbp" },
      { label: "Functions, Arrow Functions", url: "https://www.geeksforgeeks.org/functions-in-javascript/?ref=lbp" },
      { label: "Arrays", url: "https://www.geeksforgeeks.org/javascript-arrays/?ref=lbp" }
    ];
  
    // Button styling
    const buttonStyle = {
      marginLeft: '200px',
      padding: '7px',
      background: 'black',
      color: 'white',
      borderRadius: '8px'
    };
  
    return (
      <>
        <h1 className="html_gfg_heading">
          These are the <strong style={{ textDecoration: 'underline', color: 'blue' }}>Top 8</strong> recommended Geeks for Geeks links
          that you can refer with important Topics
        </h1>
  
        <h4 className="des_co_html">
          1. Dive Into The<strong> Main </strong>Concepts <br />
          2. Enough Concepts to learn & Understand  <br />
          3. Only important Concepts to learn through every topic
        </h4>
  
        {/* Part 1 Links */}
        <div className="container_html_gfg_links">
          {links.map((link, index) => (
            <p key={index} className="vid">
              {index + 1}. {link.label}
              <button
                style={buttonStyle}
                onClick={() => window.open(link.url, "_blank")}
              >
                Click Me
              </button>
            </p>
          ))}
        </div>
  
        <h3 style={{ fontFamily: 'cursive' }}>(Part - 2) Main Concepts (Medium)</h3>
  
        {/* Part 2 Links */}
        <div className="container_html_gfg_links">
          {part2Links.map((link, index) => (
            <p key={index} className="vid">
              {index + 1}. {link.label}
              <button
                style={buttonStyle}
                onClick={() => window.open(link.url, "_blank")}
              >
                Click Me
              </button>
            </p>
          ))}
        </div>
      </>
    );
  }
  export default CryptoGfg;